
export default {
  data() {
    return {
      info: '',
    }
  },
  async created() {
    await this.$store.dispatch('getShopInfo').then(res => {
      this.info = res.aboutus
    })
  },
}
